import cn from 'classnames';

import OPE from 'js/on-page-editing';
import hyphenate from 'js/utils/hyphenate';

import Image from 'components/image/Image';
import { imageSizes } from 'components/image/image-sizes';
import Link from 'components/link/Link';
import Map from 'components/map/Map';
import Tags from 'components/tags/Tags';

import { IPageHeader } from 'source/NFR.types';

const PageHeader: React.FC<IPageHeader> = ({ image, ingress, map, tags, title, portfolioLinks, onPageEditing }) => {
  return (
    <div
      className={cn('page-header', {
        'page-header--title-only': !image && !map
      })}
    >
      {title && !image && !map && (
        <h1 className="page-header--title" {...OPE(onPageEditing?.title)} {...hyphenate(title)} />
      )}
      {(image || map || ingress || (portfolioLinks && portfolioLinks.length > 0)) && (
        <div className="page-header--content">
          {title && (image || map) && (
            <h1 className="page-header--title" {...OPE(onPageEditing?.title)} {...hyphenate(title)} />
          )}
          {ingress && (
            <p className="page-header--ingress" {...OPE(onPageEditing?.ingress)}>
              {ingress}
            </p>
          )}
          {portfolioLinks && (
            <div className="page-header--links" {...OPE(onPageEditing?.links)}>
              {portfolioLinks?.map((link, index) => (
                <Link
                  className="page-header--link"
                  key={`${link.url}-${index}`}
                  theme={['large', index === 0 ? 'primary' : 'secondary']}
                  useButtonStyles
                  {...link}
                />
              ))}
            </div>
          )}
          {tags && <Tags {...tags} />}
        </div>
      )}
      {(image || map) && (
        <div className="page-header--image-or-map">
          {!map && image && <Image {...imageSizes.pageHeader} {...image} loading="eager" fetchPriority="high" />}
          {!image && map && <Map {...map} />}
        </div>
      )}
    </div>
  );
};

PageHeader.displayName = 'PageHeader';

export default PageHeader;
